<template>
  <div>
    <v-card mb-5>
      <v-toolbar flat>
        <v-toolbar-title>訂單</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="!loading">
          <transition name="fade-down" mode="out-in">
            <v-btn icon @click="() => search_shown=true" v-if="!search_shown" >
              <v-icon>search</v-icon>
            </v-btn>
            <select-textfield v-else :categories="text_filters_array" @close_clicked="() => search_shown=false" @input_changed="add_filter" />
          </transition>
        </div>
        <v-btn v-else icon disabled>
          <v-progress-circular
            :width="2"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-btn>
      </v-toolbar>
      <div class="invoice_toolbar">
        <v-btn-toggle v-model="f.marked" class="mr-2">
          <v-btn flat :value="true">
            <span>已標記</span>
            <v-icon>start</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="f.tailor" class="mr-2">
          <v-btn flat :value="true">
            <span>訂造</span>
            <v-icon>format_size</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="f.wait_for_call" class="mr-4">
          <v-btn flat :value="true">
            <span>候電</span>
            <v-icon>settings_phone</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="f.send_state">
          <v-btn flat :value="send_state.value" v-for="send_state in send_states" :key="send_state.text">
            <span>{{ send_state.text }}</span>
          </v-btn>
        </v-btn-toggle>
        <div class="pt-3 mt-3" v-if="Object.keys(t_f).length > 0" style="border-top: 1px solid lightgrey;">
          <v-chip
            v-for="(item, key) in t_f"
            :key="key"
            close
            @input="remove_filter(key)"
          >{{ text_filters[key].display }}: {{ item }}</v-chip>
        </div>
      </div>
      <v-list :class="{'disabled': loading}" two-line style="padding-top: 0;padding-bottom: 0;">
        <template v-for="(item, index) in items">
          <simple-invoice-cell @mark="markItem(index)" :key="`${item.invoice_id}_${index}`" :info="item"/>
          <v-divider
            v-if="item !== items[items.length-1]"
            :inset="true"
            :key="`divider_${index}`"
          ></v-divider>
        </template>
        <v-divider></v-divider>
        <v-list-tile ripple @click="getNext" key="loading" v-if="hasNext">
          <v-progress-circular
            :width="3"
            size="42"
            color="primary"
            indeterminate
            style="margin: 0 auto;"
            v-if="loading"
          ></v-progress-circular>
          <v-icon style="margin: 0 auto;" v-else>more_horiz</v-icon>
        </v-list-tile>
        <v-list-tile key="no_more" v-else>
          <p style="color: rgb(200,200,200);margin: 0 auto;">沒有更多訂單...</p>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash'
import { mapState } from 'vuex'

import { invoices } from '@/api'
import store from '@/store'

import SimpleInvoiceCell from '@/components/SimpleInvoiceCell'
import SelectTextField from '@/components/SelectTextField'
import ScrollNext from '@/components/ScrollNext'

const TEXT_FILTERS = {
  'invoice_id': {
    display: '訂單編號',
  },
  'primary_telephone__contains': {
    display: '電話',
  },
  'address__contains': {
    display: '地址'
  },
  'side_note__contains': {
    display: '備註',
  },
}

const TEXT_FILTERS_ARRAY = Object.keys(TEXT_FILTERS).reduce(function (previous, key) {
  previous.push({text: TEXT_FILTERS[key].display, value: key})
  return previous
}, []);

export default {
  name: 'main-view',
  data () {
    return {
      search_shown: false,
      loading: false,
      hasNext: true,
      next: null,
      items: [],
      f: {
        wait_for_call: false,
        tailor: false,
        send_state: null,
        marked: false
      },
      t_f: {},
    }
  },
  computed: {
    ...mapState({
      send_states: state => state.options.options.SEND_STATES && state.options.options.SEND_STATES.map(state => ({ text: state[1], value: state[0] }))
    }),
    filters() {
      let obj = {...this.f, ...this.t_f}
      return _.pickBy(obj, _.identity)
    },
    text_filters() {
      return TEXT_FILTERS
    },
    text_filters_array() {
      return TEXT_FILTERS_ARRAY
    }
  },
  watch: {
    'filters'() {
      this.loading = true
      this.getInvoices()
    }
  },
  methods: {
    remove_filter(key) {
      this.$delete(this.t_f, key)
    },
    add_filter(value) {
      this.t_f = {...this.t_f, ...value}
    },
    getInvoices() {
      invoices.get(null, this.filters).then((response) => {
        this.items = response.data.results
        this.hasNext = response.data.next ? true : false
        this.next = response.data.next

        this.loading = false
      }).catch(response => {
        this.loading = false
      })
    },
    getNext()  {
      invoices.get_path(this.next).then((response) => {
        this.items = this.items.concat(response.data.results)
        this.hasNext = response.data.next ? true : false
        this.next = response.data.next

        this.loading = false
      }).catch(response => {
        this.loading = false
      })
    },
    markItem(index) {
      this.$store.dispatch('load', invoices.mark(this.items[index]).then(response => this.items.splice(index, 1, response.data)))
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('load', invoices.get().then(response => { 
      next(vm => {
        vm.items = response.data.results
        vm.hasNext = response.data.next ? true : false
        vm.next = response.data.next
      }) 
    }))
  },
  components: {
    SimpleInvoiceCell,
    ScrollNext,
    'select-textfield': SelectTextField
  },
}
</script>

<style scoped>
.invoice_toolbar {
  padding: 16px;
}

.v-btn-toggle--selected {
  box-shadow: none !important;
}

.fade-down-enter-active, .fade-down-leave-active {
  transition: all .25s;
}
.fade-down-enter, .fade-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}

.fade-enter-active, .fade-leave-active {
  transition: all .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-list {
  transition: opacity .15s;
}
.v-list.disabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/MainView.vue